import loadable from '@loadable/component';

export const ReactDatePickerWrapperLoadable = loadable(
  () => import('./ReactDatePickerWrapper'),
  {
    resolveComponent: (module) => module.ReactDatePickerWrapper,
    fallback: <input readOnly />,
    ssr: false,
  },
);
